import React from 'react';
import { PropTypes } from 'prop-types';

const AccionaIcon = ({
  classIcon,
  onClick,
  id,
  className,
  hidden,
  style,
  styleIcon,
  disabled,
  toolTip,
  children,
  loading,
}) => (
  <button
    key={id}
    disabled={disabled}
    title={toolTip}
    style={style}
    hidden={hidden}
    className={className}
    onClick={onClick}
    type="button"
    id="AccionaIcon"
  >
    {' '}
    {loading ? (
      <i className="fas fa-spinner fa-spin" style={styleIcon} />
    ) : (
      <>
        <i className={classIcon} style={styleIcon} />
        {children}
      </>
    )}
  </button>
);

AccionaIcon.propTypes = {
  classIcon: PropTypes.string,
  hidden: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  styleIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  disabled: PropTypes.bool,
  toolTip: PropTypes.string,
  children: PropTypes.element,
  loading: PropTypes.bool,
};

AccionaIcon.defaultProps = {
  classIcon: undefined,
  hidden: false,
  className: 'btn',
  onClick: () => {},
  id: '',
  style: {},
  styleIcon: {},
  disabled: false,
  toolTip: '',
  children: undefined,
  loading: false,
};

export default AccionaIcon;
